<template>
    <div class="page epay" v-if="gatewayInfo && gatewayInfo.giftcard">
        <form @submit.prevent="nextStage" class="container">
            <div class="h1">Your payment information</div>
            <div class="flexWrapDesk">
                <div class="contactInfo">
                    <div class="h3">Contact Info</div>
                    <div class="formRow">
                        <input type="text" placeholder="First Name" v-model="contact_info.fname">
                    </div>
                    <div class="formRow">
                        <input type="text" placeholder="Last Name" v-model="contact_info.lname">
                    </div>
                    <div class="formRow">
                        <input type="email" placeholder="Email" v-model="contact_info.email">
                    </div>
                    <div class="formRow">
                        <input type="tel" placeholder="Phone Number" v-model="contact_info.phone">
                    </div>
                </div>
                <div class="paymentInfo">
                    <div class="h3">Payment info</div>
                    <CartPaymentsOption :no-title="true" :for-gift-cards="true"/>
                </div>
            </div>
            <div class="btnBox">
                <button class="smlBtn">
                    next
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import CartPaymentsOption from "../../components/checkout/CartPaymentsOption";
    export default {
        name: "EgiftPayment",
        components: {CartPaymentsOption},
        created() {
            this.$store.commit("shared/setTopBar", {title: "Send an E-Gift", showBackButton: true, showBag: false});
            if (!this.giftCardData.cards.length) {
                this.$router.push({name: 'E-gifts'})
                return false;
            }

            if (this.user) {
                this.contact_info.name = this.user.first_name + " " + this.user.last_name;
                this.contact_info.fname = this.user.first_name;
                this.contact_info.lname = this.user.last_name;
                this.contact_info.email = this.user.email;
                this.contact_info.phone = this.user.country_code + this.user.phone;
                this.giftCardData.purchaser.user_id = this.user.member_id;
            }
            this.$store.dispatch("shared/getGatewayInfo",{giftcardTypeId: this.giftCardData.cards[0].type_id})
        },
        methods: {
            nextStage() {
                if (this.cart.card){
                    this.contact_info.name = this.contact_info.fname + " " + this.contact_info.lname

                    let payment = {
                        card_number: this.cart.card.credit_card_number,
                        credit_card_id: this.cart.card.credit_card_id,
                        gateway_id: this.gatewayInfo.gateway_id,
                        business_id: 1329
                    }
                    this.$store.commit("giftcard/setPaymentInfo", payment);
                    this.$router.push({name: "EgiftConfirm"});
                }
                
            }
        },
        computed: {
            giftCardData(){
                return this.$store.state.giftcard.giftCardData
            },
            contact_info(){
                return this.$store.state.giftcard.giftCardData.contact_info
            },
            gatewayInfo(){
                return this.$store.state.shared.gatewayInfo
            },
            cart(){
                return this.$store.state.cart.cart
            }
        }
    }
</script>

